<template>
  <div class="newPaymentMethod">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for>
                      Descrição
                      <span class="required-field">*</span>
                    </label>
                    <input v-model="payment_method.description" type="text" class="form-control" />
                  </div>
                </div>         
                <div class="col-lg-12 col-12">
                  <div class="form-group">
                    <label for>
                      Tipo
                      <span class="required-field">*</span>
                    </label>
                    <select class="form-control" v-model="payment_method.method">
                      <option>{{"Boleto Bancário"}}</option>
                      <option>{{"Cartão de crédito"}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <label for>
                      Parcelas
                    </label>
                    <input v-model="payment_method.parcel" type="text" class="form-control" />
                    <span class="required-field">Se este campo não for preenchido será salvo como Á Vista</span>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <label for>
                      Valor mínimo <span style="color:grey">[R$]</span>
                      <span class="required-field">*</span>
                    </label>
                    <currency-input
                    v-model="payment_method.min_value"
                    :currency="{prefix: 'R$ '}"
                    locale="de"
                    class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button class="btn btn-primary float-right" v-on:click="save()">Salvar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import TextEditorComponent from "@/components/inputs/TextEditorComponent";
import Multiselect from "vue-multiselect";
import PaymentMethodValidate from "@/imports/validator/models/payment_method";
import validator from "@/imports/validator/validate";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "newPaymentMethod",
  props: {
    id: Number
  },
  components: {
    TextEditorComponent,
    Multiselect
  },
  data() {
    return {
      tempFile: "",
      formType: "create",
      payment_method: {}, 
      items: [
        {
          text: "Métodos de Pagamento",
          route: "admin.payment_methods"
        },
        {
          text: "Novo Método",
          active: true
        }
      ],
    };
  },
  mounted() {
    if(this.id)
      this.getDataObject(this.id);
  },
  methods: {
    getDataObject: function(id) {
      bus.$emit('changeLoading', true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/payment_methods/${id}`)
        .then(response => {
          this.payment_method = response.data;
          this.items[1].text = this.payment_method.description;
          this.formType = "edit";
          bus.$emit('changeLoading', false);
        });
    },
    save: function() {
      bus.$emit('changeLoading', true);
  
      let errors = validator.validate(this.payment_method, PaymentMethodValidate.model);
      
      if (errors.length == 0) {
        let promise =
          this.formType == "create"
            ? axios.post(`${process.env.VUE_APP_API_HOST}/api/payment_methods`, this.payment_method)
            : axios.put(
                `${process.env.VUE_APP_API_HOST}/api/payment_methods/${this.payment_method.id}`,
                this.payment_method
              );

        promise
          .then(response => {
            bus.$emit('changeLoading', false);
            Swal.fire({
              title:
                this.formType == "create"
                  ? "Revista cadastrada"
                  : "Revista alterada com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "admin.payment_methods" });
              }
            });
          })
          .catch(error => {
            bus.$emit('changeLoading', false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        bus.$emit('changeLoading', false);
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.newPaymentMethod {
  .toggle-input {
    height: 37px;
    label {
      margin-bottom: 0 !important;
      margin-left: 5px;
    }
  }
  .card-header {
    background-color: white;
    a {
      text-decoration: none;
      color: $red_primary;
    }
  }
  .text-content{
    margin-top: 15px
  }
  .text-indice{
    background-color: $red_primary;
    width: fit-content;
    color: white;
    padding: 3px 10px;
    margin-bottom: 15px;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
